<template>
    <v-app class="min-h-screen">
        <v-app-bar
            app
            color="white"
            height="64"
            elevate-on-scroll
            :class="$vuetify.breakpoint.smAndUp ? 'px-6' : null"
        >
            <a href="https://musicologielessons.com">
                <jet-application-logo
                    class="block w-auto"
                    :class="$vuetify.breakpoint.xs ? 'h-6' : 'h-9'"
            /></a>
            <v-spacer />
            <div class="flex gap-2 justify-end">
                <v-btn
                    v-if="false"
                    outlined
                    href="/get-started"
                    color="primary"
                    class="white--text soli-round"
                    >Get Started</v-btn
                >
                <SoliBtn
                    gradient="gradient-orange"
                    href="/login"
                    style="color: white !important"
                    >Login</SoliBtn
                >
            </div>
        </v-app-bar>

        <v-main>
            <v-container
                class="text-start"
                :class="$vuetify.breakpoint.smAndUp ? 'px-10' : 'px-4'"
                fluid
            >
                <v-row>
                    <v-col>
                        <h2 class="text-h4 font-weight-bold mb-3 soli-grey">
                            Terms and Conditions
                        </h2>
                        <div class="text-body-1 mb-4">
                            These Terms and Conditions govern your participation
                            in music lessons, use of our scheduling software,
                            and any related services provided by [Your Company
                            Name] ("Company," "we," "us," "our"). By registering
                            for lessons or using our website/software, you
                            acknowledge and accept these terms.
                        </div>

                        <h2 class="text-h5 font-weight-bold mb-3 soli-grey">
                            Lesson Policies
                        </h2>
                        <div class="text-body-1 mb-4">
                            Lessons are scheduled based on availability and may
                            be held in person or online. Students are expected
                            to arrive on time for their lessons. If an
                            instructor is unavailable, we may provide a
                            substitute teacher or reschedule.
                        </div>

                        <h2 class="text-h5 font-weight-bold mb-3 soli-grey">
                            Payment & Refund Policy
                        </h2>
                        <div class="text-body-1 mb-4">
                            Membership payments are due on the 1st of each
                            month. Late payments may result in lesson suspension
                            until payment is received. Refund Policy: All
                            payments are non-refundable, except in cases of
                            extended instructor absence or company closure.
                        </div>

                        <h2 class="text-h5 font-weight-bold mb-3 soli-grey">
                            Cancellations & Rescheduling
                        </h2>
                        <div class="text-body-1 mb-4">
                            Private Lessons: A minimum of 24 hours' notice is
                            required to reschedule without penalty. Group
                            Classes: A minimum of 30 minutes' notice is required
                            to qualify for rescheduling. Missed lessons or
                            cancellations made after these timeframes are not
                            eligible for rescheduling or credit.
                        </div>

                        <h2 class="text-h5 font-weight-bold mb-3 soli-grey">
                            Code of Conduct
                        </h2>
                        <div class="text-body-1 mb-4">
                            Students and parents are expected to treat
                            instructors and staff with respect. Disruptive,
                            inappropriate, or unsafe behavior may result in
                            lesson termination.
                        </div>

                        <h2 class="text-h5 font-weight-bold mb-3 soli-grey">
                            Scheduling Software Terms
                        </h2>
                        <div class="text-body-1 mb-4">
                            Our software is provided for scheduling lessons,
                            tracking progress, and making payments. Users must
                            not share login credentials or misuse the software.
                            We may update or modify the software at any time.
                        </div>
                        <h2 class="text-h5 font-weight-bold mb-3 soli-grey">
                            Marketing & Communication Consent
                        </h2>
                        <div class="text-body-1 mb-4">
                            By signing up, you agree that we may send you:
                            Transactional Messages – Appointment reminders,
                            schedule updates, and payment notifications.
                            Marketing Messages – Promotions, special offers, and
                            news about our services. Opting out of marketing
                            does not affect your ability to receive
                            transactional messages. You can opt out of either
                            message type at anytime by replying STOP or by
                            adjusting your preferences.
                        </div>
                        <h2 class="text-h5 font-weight-bold mb-3 soli-grey">
                            Changes to These Terms
                        </h2>
                        <div class="text-body-1 mb-4">
                            We may update these Terms and Conditions from time
                            to time. Continued participation in lessons or use
                            of our software constitutes acceptance of the
                            updated terms.
                        </div>
                        <h2 class="text-h5 font-weight-bold mb-3 soli-grey">
                            Termination of Services
                        </h2>
                        <div class="text-body-1 mb-4">
                            We reserve the right to terminate lessons or
                            services due to: Non-payment Repeated
                            cancellations/no-shows Violations of our Code of
                            Conduct
                        </div>
                        <h2 class="text-h5 font-weight-bold mb-3 soli-grey">
                            Contact Information
                        </h2>
                        <div class="text-body-1 mb-4">
                            If you have any questions about these Terms and
                            Conditions, please contact your local Musicologie
                            studio or email us at info@musicologielessons.com
                        </div>
                    </v-col></v-row
                >
            </v-container>
        </v-main>

        <SiteFooter />
    </v-app>
</template>

<script>
import JetApplicationLogo from "./../Jetstream/ApplicationLogo";
import SiteFooter from "../Layouts/Components/SiteFooter.vue";

export default {
    components: {
        JetApplicationLogo,
        SiteFooter,
    },
};
</script>

<style scoped>
.v-application a {
    color: #2aabe6 !important;
}

.v-application .display-2 {
    font-family: "Nunito", sans-serif, system-ui, -apple-system,
        BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
        "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol", "Noto Color Emoji" !important;
}

.v-application .display-1 {
    font-family: "Nunito", sans-serif, system-ui, -apple-system,
        BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
        "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol", "Noto Color Emoji" !important;
}

.v-application {
    font-family: "Nunito", sans-serif, system-ui, -apple-system,
        BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
        "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol", "Noto Color Emoji" !important;
} /*
.v-application .headline {
  font-family: Lato, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}*/

/*.v-application {
  font-family: "Nunito", sans-serif !important;
}*/
.v-application .primary--text {
    color: #228cbd !important;
    caret-color: #228cbd !important;
}
@media (min-width: 1264px) {
    .v-application .text-lg-h4 {
        font-size: 1.8rem !important;
        line-height: 1.8rem;
        letter-spacing: 0.0073529412em !important;
    }
}
</style>
